import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import animationMenu from "./animationMenu";


export default function () {
	gsap.registerPlugin(ScrollTrigger);

	animationMenu()
}